/* EP Runde 14 (17.10.2026): ausgelagert aus templates/product.json › Section custom_liquid_nRLj3g. Läuft mit defer nach dem Parsen; braucht #epn-pdp, #epn-description, #epnData. */
  (function () {
    'use strict';

    var root = document.getElementById('epn-pdp');
    var desc = document.getElementById('epn-description');
    if (!root || !desc) return;

    /* Fremdes <style>/<script> aus der Beschreibung sofort entfernen */
    Array.prototype.slice.call(desc.querySelectorAll('style, script')).forEach(function (n) { n.remove(); });

    var DATA;
    try { DATA = JSON.parse(document.getElementById('epnData').textContent); }
    catch (e) { return; }

    /* EP Runde 25 (18.10.2026): Hintergrundbilder (epn-hero-bg / epn-band-bg) wurden ohne
       Breitenparameter in Originalgröße geladen. Shopify-CDN-URLs bekommen jetzt &width=,
       sofern noch keine Breite gesetzt ist (Hero volle Breite -> 1400, Statement-Band -> 900). */
    function epnSized(url, w) {
      if (!url || url.indexOf('cdn.shopify.com/s/files/') === -1 || /[?&]width=/.test(url)) return url;
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }
    if (DATA.hero) DATA.hero = epnSized(DATA.hero, 1400);
    if (DATA.band) DATA.band = epnSized(DATA.band, 900);

    /* Höchstens vier Bilder verwenden. Ohne Grenze bekommt ein
       Produkt mit vielen Sorten in jeder Sektion ein Bild und ein
       Produkt mit zwei Bildern fast keins – dadurch sieht derselbe
       Aufbau bei jedem Produkt anders aus. */
    var MAX_IMAGES = 4;
    var gallery = (DATA.gallery || []).slice(0, MAX_IMAGES);
    var variants = DATA.variants || [];
    var index = Math.max(0, variants.findIndex(function (v) { return v.id === DATA.current; }));

    var tpl = document.getElementById('epnParts').content;
    var tipEl = tpl.querySelector('#epnTip');

    var out = document.createDocumentFragment();

    function makeSection(classes) {
      var sec = document.createElement('section');
      sec.className = 'epn-sec' + (classes ? ' ' + classes : '');
      var inner = document.createElement('div');
      inner.className = 'epn-inner';
      sec.appendChild(inner);
      return { sec: sec, inner: inner };
    }

    /* ---------- 1) HERO aus .ep-header + erster .ep-benefits-list ---------- */
    var header = desc.querySelector('.ep-header');
    var claims = desc.querySelector('ul.ep-benefits-list');

    if (header) {
      var hero = document.createElement('section');
      hero.className = 'epn-sec epn-hero epn-full';
      var heroInner = document.createElement('div');
      heroInner.className = 'epn-inner';

      if (DATA.hero) {
        /* Eigener Clip-Container: die Sektion selbst braucht auf Mobil
           overflow:visible für die überstehende Claim-Karte, das Motiv
           muss aber beschnitten werden können. */
        var bgWrap = document.createElement('div');
        bgWrap.className = 'epn-hero-media';
        bgWrap.setAttribute('aria-hidden', 'true');

        var bgImg = document.createElement('img');
        bgImg.className = 'epn-hero-bg';
        /* EP Speed2 (25.10.2026): Motiv liegt weit unter dem Falz -> erst beim Heranscrollen laden.
           src wird erst gesetzt, wenn das Bild im Dokument steht (siehe unten nach desc.appendChild) –
           ein Bild, das noch im DocumentFragment hängt, lädt Chrome trotz loading=lazy sofort. */
        bgImg.loading = 'lazy';
        bgImg.decoding = 'async';
        bgImg.setAttribute('data-epn-src', DATA.hero);
        bgImg.alt = '';
        bgImg.setAttribute('fetchpriority', 'low');

        bgWrap.appendChild(bgImg);
        hero.appendChild(bgWrap);
      }

      var heroCol = document.createElement('div');
      heroCol.className = 'epn-col';
      while (header.firstChild) heroCol.appendChild(header.firstChild);
      heroInner.appendChild(heroCol);

      if (claims) {
        var claimParent = claims.closest('.ep-section, .ep-section-alt');
        claims.classList.add('epn-claims');
        Array.prototype.slice.call(claims.children).forEach(function (li) {
          var text = document.createElement('span');
          while (li.firstChild) text.appendChild(li.firstChild);
          var check = document.createElement('span');
          check.className = 'epn-check';
          check.setAttribute('aria-hidden', 'true');
          li.appendChild(text);
          li.appendChild(check);
        });
        heroInner.appendChild(claims);

        // Übrig gebliebene Überschrift ohne Inhalt entfernen
        if (claimParent && !claimParent.querySelector('p, ul, table')) claimParent.remove();
      }

      hero.appendChild(heroInner);
      out.appendChild(hero);
      header.remove();
    }

    /* ---------- 2) Übrige Blöcke einsammeln ---------- */
    var blocks = Array.prototype.slice.call(
      desc.querySelectorAll('.ep-section, .ep-section-alt, .ep-faq-section')
    ).filter(function (el) {
      return el.textContent.trim().length > 0;
    });

    var toneStep = 0;
    var imageStep = 0;
    var statementBuilt = false;

    blocks.forEach(function (block) {
      /* --- FAQ --- */
      if (block.classList.contains('ep-faq-section')) {
        var faq = makeSection('');
        var title = block.querySelector('.ep-faq-title');
        var wrap = document.createElement('div');
        wrap.className = 'epn-faqwrap';
        if (title) wrap.appendChild(title);

        Array.prototype.slice.call(block.querySelectorAll('.ep-faq-item')).forEach(function (item) {
          wrap.appendChild(item);
        });

        faq.inner.appendChild(wrap);
        out.appendChild(faq.sec);
        return;
      }

      /* --- Statement-Band mit Foto --- */
      if (block.classList.contains('ep-center-text')) {
        var st = makeSection('is-band is-statement epn-full');
        while (block.firstChild) st.inner.appendChild(block.firstChild);

        if (DATA.band) {
          st.sec.classList.add('has-photo');
          var bandImg = document.createElement('img');
          bandImg.className = 'epn-band-bg';
          bandImg.loading = 'lazy';
          bandImg.decoding = 'async';
          bandImg.setAttribute('data-epn-src', DATA.band); /* EP Speed2: src erst im Dokument, s. u. */
          bandImg.alt = '';
          bandImg.setAttribute('aria-hidden', 'true');
          st.sec.insertBefore(bandImg, st.inner);
          statementBuilt = true;
        }

        out.appendChild(st.sec);
        return;
      }

      /* --- Normale Sektion --- */
      var band = toneStep % 2 === 1;
      var built = makeSection(band ? 'is-band epn-full' : '');
      toneStep++;

      var heading = block.querySelector('h2, h3');
      var isAnwendung = heading && heading.textContent.trim().toLowerCase().indexOf('anwendung') === 0;
      if (isAnwendung) built.sec.dataset.role = 'anwendung';
      var entry = gallery[imageStep];

      if (entry) {
        var col = document.createElement('div');
        col.className = 'epn-col';
        while (block.firstChild) col.appendChild(block.firstChild);

        var split = document.createElement('div');
        split.className = 'epn-split' + (imageStep % 2 === 1 ? ' is-media-left' : '');

        var caption = (entry.label || '').trim();

        var media = document.createElement('figure');
        media.className = 'epn-media';

        /* Querformat auf Mobil, Hochformat ab 769px.
           Spart auf schmalen Displays deutlich Scrollweg. */
        var picture = document.createElement('picture');
        if (entry.urlWide) {
          var srcWide = document.createElement('source');
          srcWide.media = '(max-width: 768px)';
          srcWide.srcset = entry.urlWide;
          picture.appendChild(srcWide);
        }
        var img = document.createElement('img');
        img.src = entry.url;
        img.alt = caption ? DATA.title + ' – ' + caption : DATA.title;
        img.loading = 'lazy';
        picture.appendChild(img);
        media.appendChild(picture);

        if (caption) {
          var cap = document.createElement('figcaption');
          cap.textContent = caption;
          media.appendChild(cap);
        }

        /* Überschrift aus der Textspalte holen und über den Split
           setzen. Auf Mobil steht sie damit vor dem Bild, auf dem
           Desktop bleibt sie oben links wie bisher. */
        var colHeading = col.querySelector('h2, h3');
        if (colHeading) colHeading.classList.add('epn-sec-head');

        split.appendChild(col);
        split.appendChild(media);
        built.inner.appendChild(split);
        imageStep++;
      } else {
        while (block.firstChild) built.inner.appendChild(block.firstChild);
      }

      out.appendChild(built.sec);
    });

    desc.innerHTML = '';
    desc.appendChild(out);
    /* EP Speed2 (25.10.2026): Hintergrundmotive erst jetzt (im Dokument) mit URL versehen -> loading=lazy greift */
    Array.prototype.slice.call(desc.querySelectorAll('img[data-epn-src]')).forEach(function (im) {
      im.src = im.getAttribute('data-epn-src');
      im.removeAttribute('data-epn-src');
    });

    /* Anwendungstipp in die Anwendungssektion, sonst in die erste Sektion */
    if (tipEl) {
      var tipHost = desc.querySelector('.epn-sec[data-role="anwendung"] .epn-col')
                 || desc.querySelector('.epn-sec[data-role="anwendung"] .epn-inner')
                 || desc.querySelector('.epn-sec:not(.epn-hero) .epn-col')
                 || desc.querySelector('.epn-sec:not(.epn-hero) .epn-inner');
      if (tipHost) tipHost.appendChild(tipEl);
    }

    /* Kein .ep-center-text vorhanden? Dann bekommt das letzte schwarze
       Band das zweite Motiv, damit es nicht ungenutzt bleibt. */
    if (!statementBuilt && DATA.band) {
      var bands = desc.querySelectorAll('.epn-sec.is-band');
      var target = bands[bands.length - 1];
      if (target) {
        target.classList.add('has-photo');
        var fbImg = document.createElement('img');
        fbImg.className = 'epn-band-bg';
        fbImg.src = DATA.band;
        fbImg.alt = '';
        fbImg.setAttribute('aria-hidden', 'true');
        fbImg.loading = 'lazy';
        target.insertBefore(fbImg, target.firstChild);
      }
    }

    /* ---------- Mobil: Claim-Karte über die Hero-Kante ziehen ----------
       Die Karte soll zur Hälfte auf dem Motiv und zur Hälfte auf der
       weißen Fläche darunter liegen. Die Höhe der Karte ist vom
       Produkt abhängig, deshalb wird sie gemessen statt geschätzt. */
    (function () {
      var heroSec = desc.querySelector('.epn-sec.epn-hero');
      if (!heroSec) return;

      var card = heroSec.querySelector('ul.epn-claims');
      var next = heroSec.nextElementSibling;
      if (!card) return;

      var mq = window.matchMedia('(max-width: 768px)');
      var OVERLAP = 0.22;

      function apply() {
        if (!mq.matches) {
          card.style.marginBottom = '';
          if (next) next.style.paddingTop = '';
          return;
        }

        card.style.marginBottom = '';
        var shift = Math.round(card.offsetHeight * OVERLAP);
        card.style.marginBottom = '-' + shift + 'px';
        /* Kein Zuschlag: der Abstand ergibt sich allein aus dem
           Überstand der Karte. Über OVERLAP steuerbar. */
        if (next) next.style.paddingTop = shift + 'px';
      }

      apply();

      if (mq.addEventListener) mq.addEventListener('change', apply);
      else if (mq.addListener) mq.addListener(apply);

      var timer;
      window.addEventListener('resize', function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(apply, 150);
      });

      /* Nach dem Laden der Schriften kann sich die Kartenhöhe ändern */
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(apply);
      window.addEventListener('load', apply);
    })();

    /* ---------- Mobil: Überschrift vor das Bild ziehen ----------
       Auf dem Desktop bleibt die Überschrift in der Textspalte, damit
       sie mit dem Absatz einen Block bildet, der mittig zum Bild sitzt.
       Auf Mobil soll sie dagegen vor dem Bild stehen. */
    (function () {
      var mqHead = window.matchMedia('(max-width: 768px)');
      var pairs = Array.prototype.slice.call(desc.querySelectorAll('.epn-split')).map(function (split) {
        var col = split.querySelector('.epn-col');
        var head = col ? col.querySelector('.epn-sec-head') : split.querySelector('.epn-sec-head');
        return { split: split, col: col, head: head };
      }).filter(function (p) { return p.split && p.col && p.head; });

      function place(isMobile) {
        pairs.forEach(function (p) {
          if (isMobile) {
            if (p.head.parentNode !== p.split) p.split.insertBefore(p.head, p.split.firstChild);
          } else if (p.head.parentNode !== p.col) {
            p.col.insertBefore(p.head, p.col.firstChild);
          }
        });
      }

      place(mqHead.matches);
      if (mqHead.addEventListener) mqHead.addEventListener('change', function (e) { place(e.matches); });
      else if (mqHead.addListener) mqHead.addListener(function (e) { place(e.matches); });
    })();

    /* ---------- Mobil: Bild der Anwendungssektion auslagern ----------
       Auf schmalen Displays liegt das Produktbild sonst auf dem
       Hintergrundfoto der Sektion. Es wandert deshalb komplett
       unter die Sektion auf weißen Grund. */
    (function () {
      var sec = desc.querySelector('.epn-sec[data-role="anwendung"]');
      if (!sec) return;

      var media = sec.querySelector('.epn-media');
      var split = sec.querySelector('.epn-split');
      if (!media || !split) return;

      var outer = document.createElement('div');
      outer.className = 'epn-sec epn-media-out';
      var inner = document.createElement('div');
      inner.className = 'epn-inner';
      outer.appendChild(inner);

      var mq = window.matchMedia('(max-width: 768px)');

      function place(isMobile) {
        if (isMobile) {
          if (media.parentNode !== inner) {
            inner.appendChild(media);
            sec.insertAdjacentElement('afterend', outer);
            split.style.display = 'block';
          }
        } else if (media.parentNode !== split) {
          split.appendChild(media);
          split.style.display = '';
          if (outer.parentNode) outer.remove();
        }
      }

      place(mq.matches);
      if (mq.addEventListener) mq.addEventListener('change', function (e) { place(e.matches); });
      else if (mq.addListener) mq.addListener(function (e) { place(e.matches); });
    })();

    /* ---------- Mobil: Abstand über dem Block schließen ----------
       Der umgebende Theme-Container (div.container--vertical-space)
       hat margin-top: 60px. Er ist transparent, dadurch scheint der
       Seitenhintergrund als grauer Streifen über dem Hero durch.
       Auf Mobil wird dieser Abstand für diesen einen Container
       aufgehoben, damit das Motiv bündig oben anschließt. */
    (function () {
      var wrap = root.parentElement;
      if (!wrap) return;

      var mqTop = window.matchMedia('(max-width: 768px)');

      function fit() {
        if (mqTop.matches) {
          /* !important, weil das Theme den Abstand selbst mit
             !important setzt und ein einfacher Inline-Style verliert. */
          wrap.style.setProperty('margin-top', '0', 'important');
          wrap.style.setProperty('padding-top', '0', 'important');

          /* Sicherheitsnetz: auch die Ebene darüber prüfen */
          var up = wrap.parentElement;
          if (up && up !== document.body) {
            var cs = window.getComputedStyle(up);
            if (parseInt(cs.marginTop, 10) > 0) up.style.setProperty('margin-top', '0', 'important');
            if (parseInt(cs.paddingTop, 10) > 0) up.style.setProperty('padding-top', '0', 'important');
          }
        } else {
          wrap.style.removeProperty('margin-top');
          wrap.style.removeProperty('padding-top');
          var up2 = wrap.parentElement;
          if (up2) {
            up2.style.removeProperty('margin-top');
            up2.style.removeProperty('padding-top');
          }
        }
      }

      fit();
      if (mqTop.addEventListener) mqTop.addEventListener('change', fit);
      else if (mqTop.addListener) mqTop.addListener(fit);
    })();

    /* ---------- Tabellen scrollbar machen ---------- */
    Array.prototype.slice.call(desc.querySelectorAll('table')).forEach(function (table) {
      if (table.parentNode.classList.contains('epn-table-scroll')) return;
      var w = document.createElement('div');
      w.className = 'epn-table-scroll';
      table.parentNode.insertBefore(w, table);
      w.appendChild(table);
    });

    /* ---------- 3) FAQ verdrahten ---------- */
    Array.prototype.slice.call(desc.querySelectorAll('.ep-faq-item')).forEach(function (item, i) {
      var btn = item.querySelector('.ep-faq-question');
      var answer = item.querySelector('.ep-faq-answer');
      var content = item.querySelector('.ep-faq-answer-content');
      if (!btn || !answer || !content) return;

      btn.removeAttribute('onclick');
      var arrow = btn.querySelector('.ep-faq-arrow');
      if (arrow) arrow.remove();

      var sign = document.createElement('span');
      sign.className = 'epn-faq-sign';
      sign.setAttribute('aria-hidden', 'true');
      btn.appendChild(sign);

      answer.id = 'epn-faq-a-' + i;
      btn.setAttribute('type', 'button');
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', answer.id);
      answer.style.maxHeight = '0px';

      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        answer.style.maxHeight = open ? '0px' : content.scrollHeight + 'px';
      });
    });

    /* FAQPage JSON-LD */
    (function () {
      var entries = Array.prototype.slice.call(desc.querySelectorAll('.ep-faq-item')).map(function (item) {
        var q = item.querySelector('.ep-faq-question');
        var a = item.querySelector('.ep-faq-answer-content');
        if (!q || !a) return null;
        return {
          '@type': 'Question',
          name: q.textContent.trim(),
          acceptedAnswer: { '@type': 'Answer', text: a.textContent.trim() }
        };
      }).filter(Boolean);

      if (!entries.length) return;
      var ld = document.createElement('script');
      ld.type = 'application/ld+json';
      ld.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: entries
      });
      document.head.appendChild(ld);
    })();

    /* ---------- 4) Varianten: nur noch der Anwendungstipp ---------- */
    var tip = document.getElementById('epnTip');
    var tipText = document.getElementById('epnTipText');
    var tipImg = document.getElementById('epnTipImg');

    function render() {
      var v = variants[index];
      if (!v || !tip) return;

      if (v.tip) {
        tipText.textContent = v.tip;
        tip.hidden = false;
        if (v.tipImg) { tipImg.src = v.tipImg; tipImg.hidden = false; }
        else { tipImg.hidden = true; }
      } else {
        tip.hidden = true;
      }
    }

    function syncFromTheme(id) {
      var i = variants.findIndex(function (v) { return String(v.id) === String(id); });
      if (i > -1 && i !== index) { index = i; render(); }
    }

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.name === 'id' && t.closest('form[action*="/cart/add"]')) syncFromTheme(t.value);
    });

    ['variant:change', 'variantChange', 'product:variant-change'].forEach(function (name) {
      document.addEventListener(name, function (e) {
        var v = e.detail && (e.detail.variant || e.detail);
        if (v && v.id) syncFromTheme(v.id);
      });
    });

    render();
  })();

/* EP Runde 26 (18.10.2026): Lighthouse „ARIA hidden element must not contain focusable elements“ –
   sections/main-product.liquid gibt .product-gallery__thumbnails mit aria-hidden="true" aus, die Thumbnails sind aber klickbar.
   Das Template ist zu groß für den Upload-Weg, deshalb wird das Attribut hier nach dem Laden entfernt. */
(function () {
  function fix() { document.querySelectorAll('.product-gallery__thumbnails[aria-hidden="true"]').forEach(function (el) { el.removeAttribute('aria-hidden'); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix); else fix();
})();
